/* eslint-disable @typescript-eslint/naming-convention */
import {AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AppService} from '@app/services/app.service';
import {Store} from '@ngxs/store';
import {AccessType, ConnectionStatus, KeyCode, LogLevel, LogResource, ViewportTab} from '@app/modules/shared/data/constants';
import {WRTCProviderService} from '@app/modules/wrtc/services/providers/wrtc-provider';
import {LocalUser, LocalUserAction, LocalUserState} from '@app/state/local-user.state';
import {LogService} from '@app/services/log.service';
import {CommandService} from '@app/services/command.service';
import {ClassroomAction, ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {MediaDeviceConfigurationComponent} from '@app/modules/shared/components/dialogs/media-device-configuration/media-device-configuration.component';
import {TeamInfoControlComponent} from '@app/modules/shared/components/dialogs/team-info-control/team-info-control.component';
import {GameModeModel, GameModeState} from '@app/state/game-mode.state';
import {ApplauseLevel, CoreService, Timer} from '@app/services/core.service';
import {AssignmentAction, AssignmentState, AssignmentStateModel} from '@app/state/assignment.state';
import {interval, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoginService} from '@app/modules/auth/services/login.service';
import {SmartsuppService} from '@app/modules/shared/services/smartsupp.service';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {AssignmentService} from '@app/modules/whiteboard/services/assignment.service';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {RemoteParticipantsInfo} from '@app/models/remote-participants-info';
import {Whiteboard, WhiteboardState} from '@app/state/whiteboard.state';
import {UtilService} from '@app/modules/shared/services/util.service';
import {WebPortalMessageType} from '@app/models/webportal/types';
import {WhiteboardService} from '@app/modules/whiteboard/services/whiteboard.service';
import {BlackboardService} from '@app/modules/blackboard/services/blackboard.service';
import {ChatService} from '@app/modules/chat/services/chat.service';
import {JsonLogService} from '@app/modules/shared/services/json-log.service';
import {UsersListService} from '@app/modules/shared/services/users-list.service';
import {Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {
  ReconnectionErrorComponent
} from '@app/modules/shared/components/dialogs/reconnection-error/reconnection-error.component';
import {PrivateWhiteboard, PrivateWhiteboardState} from '@app/state/private-whiteboard.state';
import {PrivateWhiteboardService} from '@app/modules/whiteboard/services/private-whiteboard.service';
import {WebPortalMessagingService} from '@app/services/web-portal-messaging.service';
import {Point} from '@angular/cdk/drag-drop';
import {
  RemoteUserAdditionalInfoStateModel,
  RemoteUserInfoStateModel,
  RemoteUsersInfoState
} from '@app/state/remote-users.state';

@Component({
  selector: 'app-vcr-classroom',
  templateUrl: 'vcr-classroom.component.html',
  styleUrls: ['./vcr-classroom.component.css']
})
export class VcrClassroomComponent implements OnInit, OnDestroy, AfterViewInit {
  public localUser: LocalUser;
  public classroom: ClassroomStateModel;
  public assignment: AssignmentStateModel;
  public remoteUsers: { [key: number]: RemoteUserAdditionalInfoStateModel };
  public whiteboard: Whiteboard;
  public privateWhiteboard: PrivateWhiteboard;
  public gameMode: GameModeModel;
  public currentDate = new Date();
  public activatedViewportTab = ViewportTab.BLACKBOARD;
  public viewportTabActivateEmitter$: EventEmitter<any> = new EventEmitter<any>();
  protected readonly ViewportTab = ViewportTab;
  protected privateTalkPopUpPosition: Point;


  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ViewPortTab = ViewportTab;
  public localTime = '';

  public AccessType = AccessType;
  public Object = Object;
  public UtilService = UtilService;

  // showSuggestionToSwitchToWB = false;
  public statusNotification = '';
  public isTimerPopupShown = false;
  public smartsupp = {username: '', isOpen: false, hideInterval$: new Subject(), unAnsweredMessagesCount: 0};

  @ViewChild('selectElement') selectElement: ElementRef;

  constructor(private loginService: LoginService,
              private smartsuppService: SmartsuppService,
              protected coreService: CoreService,
              protected usersListService: UsersListService,
              private cookieService: CookieService,
              private wrtcService: WrtcService,
              private assignmentService: AssignmentService,
              protected whiteboardService: WhiteboardService,
              protected privateWhiteboardService: PrivateWhiteboardService,
              private blackboardService: BlackboardService,
              private chatService: ChatService,
              private dialogService: NgbModal,
              private renderer: Renderer2,
              private webPortalMessagingService: WebPortalMessagingService,
              private store: Store,
              private applicationRef: ApplicationRef,
              private router: Router,
              private cdRef: ChangeDetectorRef) {
    this.renderer.addClass(document.body, 'vcr-classroom');
    this.wrtcService.privateTalkEndEventEmitter.subscribe(() => {
      this.privateTalkPopUpPosition = {x: 0, y: 0};
    });

    effects.onClickInFirework = () => {
      if (this.localUser.accessType === AccessType.TEACHER || this.localUser.accessType === AccessType.SUPPORT) {
        effects.toggleEffect(true);
      }
    };
    /* on start and on end send toggle */
    effects.onStart = (send: boolean) => {
      if (send) {
        this.coreService.sendFireworkOn().subscribe();
      }
    };
    effects.onEnd = (send: boolean) => {
      if (send) {
        this.coreService.sendFireworkOff().subscribe();
      }
    };
    this.listenStoreChanges();
    this.initTimer(35);
  }

  public ngOnInit(): void {
    if (this.localUser.accessType === AccessType.SUPPORT) {
      this.store.dispatch(new ClassroomAction.ToggleIsChatHidden(false));
    } else if (this.localUser.accessType === AccessType.STUDENT) {
      setInterval(() => {
        this.localTime = new Date().toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
      }, 1000);
    }

    window.addEventListener('online', (): void => {
      this.coreService.resetClassroom()
        .catch((error: any): void => {
          const dialog: NgbModalRef = this.dialogService.open(ReconnectionErrorComponent, {size: 'md'});

          dialog.result.then(() => {
            window.location.reload();
          }, (reason) => {
            console.log('dialog closed ' + reason);
          });
        })
        .then()
        .finally();
    });
  }

  public ngAfterViewInit(): void {
    this.smartsupp.username = this.smartsuppService.buildUsername(true);
    window.smartsupp('chat:hide');
    this.cdRef.detectChanges();
    window.smartsupp('on', 'message_sent', () => {
      this.smartsupp.unAnsweredMessagesCount = 0;
    });

    window.smartsupp('on', 'message_received', () => {
      if (!this.smartsupp.isOpen) {
        this.smartsupp.unAnsweredMessagesCount++;
      }
    });
  }

  public ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'vcr-classroom');
  }

  public activateViewportTab() {
    if (this.activatedViewportTab === ViewportTab.CHAT) {
      this.activatedViewportTab = ViewportTab.BLACKBOARD;
    } else {
      this.activatedViewportTab = ViewportTab.CHAT;
    }
    this.applicationRef.tick(); /* force update ui to make blackboard or chat visible */
    this.viewportTabActivateEmitter$.emit(this.activatedViewportTab);
  }

  public toggleDoNotDisturbMode(): void {
    if (this.localUser.accessType === AccessType.TEACHER || this.localUser.accessType === AccessType.SUPPORT) {

      if (this.classroom.currentClass) {
        this.coreService.sendToggleDND(!this.classroom.isDnDEnabled).subscribe();
      } else {
        alert('Please select the class.');
      }
    } else {
      // commandService.rpcLog(13, self.initData.userId, "<font color='orange'>Do Not Disturb mode is rejected - user role is STUDENT</font>");
    }
  }

  public toggleMuteClassroom(): void {

    this.wrtcService.sendMuteRoom(!this.classroom.isClassroomMuted).subscribe();
  }

  @HostListener('window:keydown', ['$event'])
  public keyDown(event: KeyboardEvent): void {
    if (event.altKey && event.code === KeyCode.KEY_M) {
      this.toggleMuteClassroom();
    }
  }

  public refreshPage(): void {
    window.location.reload();
  }

  public toggleSmartsuppChat(): void {
    if (this.smartsupp.isOpen) {
      this.smartsupp.isOpen = false;
      window.smartsupp('chat:hide');
      this.smartsupp.hideInterval$.next(0);
    } else {
      this.smartsupp.isOpen = true;
      this.smartsupp.unAnsweredMessagesCount = 0;
      window.smartsupp('chat:open');
      interval(500).pipe(takeUntil(this.smartsupp.hideInterval$)).subscribe(value => {
        const chatFrame = document.getElementById('widgetMessengerFrame');
        if (!chatFrame || chatFrame.getBoundingClientRect().height <= 400) {
          window.smartsupp('chat:hide');
          this.smartsupp.hideInterval$.next(0);

          this.smartsupp.isOpen = false;
        }
      });

    }
  }

  public logout(): void {
    const message = 'Are you leaving virtual classroom? Please make sure to close virtual classroom if your lesson is over.';
    if (this.localUser.accessType === AccessType.TEACHER || this.localUser.accessType === AccessType.SUPPORT) {
      if (window.confirm(message)) {
        this.coreService.sendLogout().subscribe(() => {
          this.loginService.logout().subscribe(redirectUrl => window.location = redirectUrl);
          this.chatService.sendSystemInfoMessage(this.localUser,' logged out.');
        });
      }
    } else {
      this.coreService.sendLogout().subscribe(() => {
        this.loginService.logout(this.localUser.isGuest, false).subscribe(redirectUrl => window.location = redirectUrl);
        this.chatService.sendSystemInfoMessage(this.localUser,' logged out.');
      });
    }
    this.whiteboardService.onLogout();
  }

  public openEndLessonDialog(): void {
    const message = 'This action will Clear all data; e.g. chat, white board, channels.\n\n';
    if (window.confirm(message)) {
      /* @TODO temporarily disabled WB snapshot saving future */
      /* save the main whiteboard snapshot then end lesson, even if snapshot saving can't be done */
      // this.coreService.exportAndSaveWhiteboardSnapshot()
      //   .then()
      //   .catch()
      //   .finally((): void => {
      //     this.endLesson();
      //   });
      this.endLesson();
    }
  }

  private endLesson(): void {
    this.coreService.sendEndLesson().subscribe();
    // rpcLog(LogEvent.AUDIT, "<font color='darkred'>Start Classroom purge</font>");
    this.cookieService.delete('virt_group_title');
    this.cookieService.delete('virt_group_id');
    LogService.writeLog('purge signal sent', LogLevel.INFO, LogResource.CORE);
  }

  public toggleRoomCollapseMode(): void {
    this.store.dispatch(new ClassroomAction.ToggleStudentsSectionCollapsed(!this.classroom.isStudentsSectionCollapsed));
  }

  public openAudioVideoDeviceConfigurationDialog(event): void {
    this.dialogService.open(MediaDeviceConfigurationComponent);
  }

  public toggleGameMode(): void {
    if (!this.gameMode.isStarted) {
      this.openStartGameModeDialog();
    } else {
      const scoreReminder = 'You are about to finish the game. All team assignments and scores will be deleted, you will not be able to resume the game. Are you sure you want to do this?';
      if (window.confirm(scoreReminder)) {
        this.coreService.sendGameMode(false).subscribe();
        // this.commandService.endGameMode().subscribe();
      }
    }
  }

  private openStartGameModeDialog(): void {
    const teams = this.gameMode.teams.map(team => ({id: team.id, name: team.name}));
    const userIdWithTeamIdList = this.usersListService.remoteUsersWrapper.students
      .filter((student: RemoteParticipantInfo) => student.additionalInfo.roomConnectionStatus === ConnectionStatus.ONLINE)
      .map(student => {
        const id = student.id;
        const item = {id: student.id, teamId: -1, displayName: student.displayName};

        if (this.gameMode.participantsTeamIndexById[id] !== undefined) {
          const teamIndex = this.gameMode.participantsTeamIndexById[id];
          item.teamId = teams[teamIndex].id;
        } else {
          item.teamId = -1;
        }
        return item;
      });

    const dialog = this.dialogService.open(TeamInfoControlComponent, {size: 'lg'});

    dialog.componentInstance.usersList = userIdWithTeamIdList;
    dialog.componentInstance.teams = teams;
    dialog.componentInstance.isInCreateMode = true;

    dialog.result.then((result) => {
      this.coreService.sendGameMode(true).subscribe();
      this.coreService.sendTeamsInfo(result.teams, result.lastTeamId).subscribe();
      this.coreService.sendResetTeamScore().subscribe();
    }, (reason) => {
      console.log('dialog closed ' + reason);
    });
  }

  public toggleFireworks(): void {
    effects.toggleEffect('fireworks', true);
  }

  public playApplauseSound() {
    this.coreService.applause(ApplauseLevel.CLASS);
    this.coreService.sendApplauseToClass().subscribe();
  }

  public sendEndPrivateTalk(): void {
    this.wrtcService.recoverMuteState();
    this.store.dispatch(new ClassroomAction.EndPrivateTalk());
    this.endPrivateWhiteboard();
    this.wrtcService.sendEndPrivateTalk().subscribe();
  }

  public switchViewPortTab(tabIndex: ViewportTab): void {
    if (tabIndex === this.ViewPortTab.ASSIGNMENT && this.assignment.isAssignmentInPendingState) {
      this.store.dispatch(new AssignmentAction.TogglePendingState(false));
    }
    if (tabIndex !== this.classroom.selectedBoardTab) {
      this.store.dispatch(new ClassroomAction.SetBoardTab(tabIndex));
      this.store.dispatch(new LocalUserAction.SetCurrentTab(tabIndex));
      this.assignmentService.sendViewPort(tabIndex).subscribe();

      if (tabIndex === ViewportTab.WHITEBOARD) {
        this.applicationRef.tick(); /* force update ui to make whiteboard wrapper visible */
        this.whiteboardService.updateScroll();
        this.whiteboardService.updateGrid();
      }
    }
  }

  public startPrivateWhiteboard(): void {
    this.wrtcService.startPrivateWhiteboard();
  }

  public endPrivateWhiteboard(): void {
    this.wrtcService.endPrivateWhiteboard();
  }

  public showPrivateWhiteboard(): void {
    this.store.dispatch(new ClassroomAction.ShowPrivateWhiteboard(true));
  }

  public hidePrivateWhiteboard(): void {
    this.store.dispatch(new ClassroomAction.ShowPrivateWhiteboard(false));
  }

  public hideAllStudentsAreOnWBMessage(): void {
    this.assignmentService.hideAllStudentsAreOnWBMessage();
  }

  public refresh(): void {
    this.store.dispatch(new AssignmentAction.RefreshAssignment());
  }

  private initTimer(maxDuration: number): void {
    let duration = 1;
    while (duration <= maxDuration) {
      this.timer.durations.push(duration);
      if (duration > 9) {
        duration += 5;
      } else {
        duration++;
      }
    }
    this.timer.durations = this.timer.durations.reverse();
  }

  public get remoteUsersWrapper(): RemoteParticipantsInfo {
    return this.usersListService.remoteUsersWrapper;
  }

  public closeTimerPopup(): void {
    this.isTimerPopupShown = false;
  }

  public startTimer(): void {
    this.coreService.sendBreakTime(this.timer.selectedDuration).subscribe();
  }

  public stopTimer(): void {
    this.coreService.sendStopBreakTime().subscribe();
  }

  public startBreakTime(): void {
    if (this.classroom.isTimerEnabled) {
      this.stopTimer();
    } else {
      this.isTimerPopupShown = true;
    }
  }

  public get timer(): Timer {
    return this.coreService.timer;
  }

  private listenStoreChanges(): void {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
      this.isTimerPopupShown = this.isTimerPopupShown && !classroom.isTimerEnabled;
    });
    this.store.select(AssignmentState).subscribe((assignmentState: AssignmentStateModel) => {
      this.assignment = assignmentState;
    });
    this.store.select(RemoteUsersInfoState).subscribe(({usersInfoById}: RemoteUserInfoStateModel): void => {
      this.remoteUsers = usersInfoById;
    });
    this.store.select(WhiteboardState).subscribe((whiteboard: Whiteboard) => {
      this.whiteboard = whiteboard;
    });
    this.store.select(PrivateWhiteboardState).subscribe((whiteboard: PrivateWhiteboard) => {
      this.privateWhiteboard = whiteboard;
    });

    this.store.select(GameModeState).subscribe((gameModeState: GameModeModel) => {
      this.gameMode = gameModeState;
    });
  }

  // this method is only for test purpose test group ids 40594 40639 40608
  public setTestClass(groupId) {
    const message = {parameters: {lesson: 'Test Lesson', lessonId: -1, topic: 'test topic', groupId}};
    // @ts-ignore
    this.webPortalMessagingService.selectGroup(message as WebPortalMessageType);
  }
}
